import { resolveCustomerFormFieldName } from "../Master/Customers/customerDynamicFormApi";

export const CUSTOMER_PRIORITY_FIELD_ORDER = [
  "companyName",
  "name",
  "accound_no",
  "addressLine1",
  "addressLine2",
];

export const CUSTOMER_RED_FIELD_NAMES = [
  "companyName",
  "name",
  "accound_no",
  "addressLine1",
  "addressLine2",
];

export const CUSTOMER_ADD_FORM_DEFAULT_FIELDS = [
  { name: "companyName", label: "Business Name", visible: true, required: true },
  { name: "name", label: "Customer Name", visible: true, required: true },
  { name: "emailId", label: "Email Address", visible: true, required: true },
  { name: "phone", label: "Phone", visible: true, required: true },
  { name: "route", label: "Route", visible: true, required: true },
  { name: "typeOfBusiness", label: "Type of Business", visible: true, required: true },
  { name: "businessCategory", label: "Business Category", visible: true, required: true },
  { name: "default_delivery", label: "Delivery Days", visible: true, required: true },
  { name: "addressLine1", label: "Address", visible: true, required: true },
  { name: "addressLine2", label: "Address 2", visible: true, required: false },
  { name: "city", label: "City", visible: true, required: true },
  { name: "county", label: "County", visible: true, required: true },
  { name: "postalCode", label: "Postal Code", visible: true, required: true },
  { name: "accound_no", label: "Account Number (User Name)", visible: true, required: true },
  { name: "vatNo", label: "VAT Number", visible: true, required: false },
  { name: "product_price", label: "Price Group", visible: true, required: false },
  { name: "credit_facility", label: "Credit Facility", visible: true, required: false },
  { name: "day_wise", label: "Day Wise", visible: true, required: false },
  { name: "total_day", label: "Total Days", visible: true, required: false },
  { name: "invoice_wise", label: "Invoice Wise", visible: true, required: false },
  { name: "total_invoice", label: "Total Invoices", visible: true, required: false },
  { name: "amount_wise", label: "Amount Wise", visible: true, required: false },
  { name: "total_amount", label: "Total Amount", visible: true, required: false },
];

export const CUSTOMER_CREDIT_DEPENDENT_FIELDS = [
  "day_wise",
  "total_day",
  "invoice_wise",
  "total_invoice",
  "amount_wise",
  "total_amount",
];

const CUSTOMER_SETTINGS_NAME_ALIASES = {
  firstName: "name",
  first_name: "name",
  customer_name: "name",
  contact_name: "name",
  name: "name",
  company_name: "companyName",
  companyName: "companyName",
  account_no: "accound_no",
  accountNo: "accound_no",
  accound_no: "accound_no",
  address_line_1: "addressLine1",
  addressLine1: "addressLine1",
  address_line_2: "addressLine2",
  addressLine2: "addressLine2",
  product_price: "product_price",
  productPrice: "product_price",
  price_group: "product_price",
  priceGroup: "product_price",
  pricegroup: "product_price",
  product_price_type: "product_price",
  credit_facility: "credit_facility",
  creditFacility: "credit_facility",
  creditfacility: "credit_facility",
  day_wise: "day_wise",
  dayWise: "day_wise",
  total_day: "total_day",
  total_days: "total_day",
  totalDays: "total_day",
  invoice_wise: "invoice_wise",
  invoiceWise: "invoice_wise",
  total_invoice: "total_invoice",
  total_invoices: "total_invoice",
  totalInvoice: "total_invoice",
  amount_wise: "amount_wise",
  amountWise: "amount_wise",
  total_amount: "total_amount",
  totalAmount: "total_amount",
};

export const resolveCustomerSettingsFieldName = (apiName = "") => {
  const raw = String(apiName || "").trim();
  if (!raw) return "";
  if (CUSTOMER_SETTINGS_NAME_ALIASES[raw]) {
    return CUSTOMER_SETTINGS_NAME_ALIASES[raw];
  }
  const lower = raw.toLowerCase().replace(/\s+/g, "_");
  if (CUSTOMER_SETTINGS_NAME_ALIASES[lower]) {
    return CUSTOMER_SETTINGS_NAME_ALIASES[lower];
  }
  return resolveCustomerFormFieldName(raw);
};

export const mapDefaultCustomerFieldRows = (
  defaults = CUSTOMER_ADD_FORM_DEFAULT_FIELDS,
) =>
  (defaults || []).map((field) => ({
    name: field.name,
    label: field.label || field.name,
    section: "",
    visible: field.visible !== false,
    required: field.required === true,
    subFields: [],
  }));

export const applyCustomerPriorityFieldDefaults = (rows = []) => {
  const byName = new Map();
  (rows || []).forEach((row) => {
    const key = resolveCustomerSettingsFieldName(row?.name || "");
    if (!key || byName.has(key)) return;
    byName.set(key, { ...row, name: key });
  });

  const defaultByName = new Map(
    mapDefaultCustomerFieldRows().map((row) => [row.name, row]),
  );
  const ordered = [];
  const used = new Set();

  CUSTOMER_PRIORITY_FIELD_ORDER.forEach((name) => {
    const existing = byName.get(name) || defaultByName.get(name);
    if (!existing) return;
    ordered.push({
      ...existing,
      name,
      label: defaultByName.get(name)?.label || existing.label || name,
      visible: true,
      required: true,
      subFields: existing.subFields || [],
    });
    used.add(name);
  });

  CUSTOMER_ADD_FORM_DEFAULT_FIELDS.forEach((field) => {
    if (used.has(field.name)) return;
    const existing = byName.get(field.name) || defaultByName.get(field.name);
    if (!existing) return;
    ordered.push({
      ...existing,
      name: field.name,
      label: defaultByName.get(field.name)?.label || existing.label || field.label || field.name,
    });
    used.add(field.name);
  });

  byName.forEach((row, name) => {
    if (used.has(name)) return;
    ordered.push(row);
  });

  const creditRow = ordered.find((row) => row.name === "credit_facility");
  if (creditRow && creditRow.visible === false) {
    const dependent = new Set(CUSTOMER_CREDIT_DEPENDENT_FIELDS);
    return ordered.map((row) =>
      dependent.has(row.name)
        ? { ...row, visible: false, required: false }
        : row,
    );
  }

  return ordered;
};
